import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=5ba97a48&scoped=true"
import script from "./FileSelect.vue?vue&type=script&lang=js"
export * from "./FileSelect.vue?vue&type=script&lang=js"
import style0 from "./FileSelect.vue?vue&type=style&index=0&id=5ba97a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba97a48",
  null
  
)

export default component.exports